import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShow = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12 17.992c-3.758 0-7.026-2.032-9.779-6.492C4.974 7.04 8.242 5.008 12 5.008s7.026 2.032 9.779 6.492c-2.753 4.46-6.021 6.492-9.779 6.492ZM12 3C7.118 3 3.173 5.814.136 11.002a.983.983 0 0 0 0 .996C3.173 17.186 7.118 20 12 20c4.882 0 8.827-2.814 11.864-8.002a.983.983 0 0 0 0-.996C20.828 5.814 16.883 3 12 3Zm-1.166 8.5c0-.628.522-1.138 1.166-1.138.644 0 1.166.51 1.166 1.138 0 .628-.522 1.138-1.166 1.138-.644 0-1.166-.51-1.166-1.138ZM12 8.354c-1.78 0-3.223 1.409-3.223 3.146 0 1.737 1.443 3.146 3.223 3.146 1.78 0 3.223-1.409 3.223-3.146 0-1.737-1.443-3.146-3.223-3.146Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShow);
export default ForwardRef;
